<div class="container">
  <h3 class="up-next-title fw-bold text-white">{{ 'fantasy.up.next.text' | translate }}</h3>
  <p class="font-size-14 mb-0 text-white">{{ 'fantasy.up.next.description' | translate }}</p>

  <div class="up-next-games d-flex flex-column">
    <ng-container *ngIf="upNextGames$ | async as games">
      @for (game of games; track game.GameId) {
        <div class="up-next-game-card d-flex flex-column align-items-center justify-content-center bg-primary">
          <div class="teams-details">
            <div class="home-team">
              <p class="team-name font-size-14 text-white fw-bold text-capitalize mb-0 text-end">
                {{ game.HomeTeamName }}
              </p>

              <ng-container *ngIf="game.HomeTeamLogo; else noHomeImage">
                <img [src]="game.HomeTeamLogo" alt="home team image" />
              </ng-container>
              <ng-template #noHomeImage>
                <img [src]="'placeholders/fallbackteamlogo.svg' | contentAssetImage" alt="home team" />
              </ng-template>
            </div>

            <span class="vs-text font-size-14 fw-bold text-uppercase text-white">
              {{ 'fantasy.game.vs' | translate }}
            </span>

            <div class="away-team">
              <ng-container *ngIf="game.AwayTeamLogo; else noAwayImage">
                <img [src]="game.AwayTeamLogo" alt="away team image" />
              </ng-container>
              <ng-template #noAwayImage>
                <img [src]="'placeholders/fallbackteamlogo.svg' | contentAssetImage" alt="home team" />
              </ng-template>
              <p class="team-name font-size-14 text-white fw-bold text-capitalize mb-0 text-start">
                {{ game.AwayTeamName }}
              </p>
            </div>
          </div>

          <p class="font-size-12 text-white mb-0">{{ game.Time }}, {{ game.Date }}</p>
        </div>
      } @empty {
        <div class="no-items w-100 text-center bg-primary">
          <div class="svg svg-info vs-svg ms-auto me-autoo" fgbAnimateSvg>
            <img class="placeholder-image" [src]="'placeholders/pick-a-player.svg' | contentAssetImage" />
          </div>
          <p class="text-center font-size-14 mb-0 text-white">
            {{ 'pick.player.upcoming.placeholder' | translate }}
          </p>
        </div>
      }
    </ng-container>
  </div>
</div>
